import { render, staticRenderFns } from "./order-push-status.vue?vue&type=template&id=2fdde7ca&"
import script from "./order-push-status.vue?vue&type=script&lang=js&"
export * from "./order-push-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports